module.exports = __webpack_public_path__ + "static/media/arrow.72eaac9e.svg";